import { render } from "./ContactUsView.vue?vue&type=template&id=5ca3e46c&scoped=true"
import script from "./ContactUsView.vue?vue&type=script&lang=js"
export * from "./ContactUsView.vue?vue&type=script&lang=js"

import "./ContactUsView.vue?vue&type=style&index=0&id=5ca3e46c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca3e46c"]])

export default __exports__